<div class="editor-container">
  <div class="editor" (click)="unselectNode()">
    <h2>
      @if (showQuestionId) {
      <span>{{ calcPlan.question.id }}.</span>
      } {{ calcPlan.question.question }} {{ questionLabels() }}
    </h2>

    <div class="chart-container">
      @for (chart of charts; track chartTrackBy($index, chart)) {
      <div
        class="chart"
        [ngStyle]="{ width: chart.width + 'px', height: chart.height + 'px' }"
      >
        @for (e of chart.edges; track edgeTrackBy($index, e)) {
        <div
          class="edge"
          [ngStyle]="e.style"
          [class]="e.cssClass"
          [ngClass]="{
            'empty-start':
              e.node.instruction.block.type === BlockType.Start &&
              e.nextNode.instruction.block.type === BlockType.Placeholder
          }"
        >
          <div
            [attr.data-test-ref]="'dropZone'"
            class="drop-zone"
            cdkDropList
            [cdkDropListSortingDisabled]="true"
            [cdkDropListEnterPredicate]="dropBlockAllowed(chart, e)"
            (cdkDropListDropped)="dropBlockOnEdge($event, chart, e)"
            [ngStyle]="e.dropZoneStyle"
          >
            <div class="plus">
              <div class="horizontal"></div>
              <div class="vertical"></div>
            </div>
          </div>
          <div class="edge-bg"></div>
          @if (e.label) {
          <div class="label" [ngStyle]="e.labelStyle">{{ e.label }}</div>
          }
        </div>
        } @for (n of chart.nodes; track nodeTrackBy($index, n)) {
        <div
          class="node"
          [class]="n.instruction.block.type.toLowerCase()"
          [ngClass]="{
            selected: n === selectedNode,
            highlighted: n.instruction.id === hoveredInstructionId,
            'missing-info-warning':
              n.instruction.block.id === 'warning-missing-info'
          }"
          [ngStyle]="n.style"
          (click)="selectNode(n, chart); $event.stopPropagation()"
          cdkDropList
          cdkDropListHasAnchor
          [cdkDropListSortingDisabled]="true"
          [cdkDropListEnterPredicate]="falseListEnterPredicate"
        >
          <div
            cdkDrag
            [cdkDragDisabled]="!canDragNode(chart.program, n)"
            [cdkDragData]="instructionAsDragData(n.instruction)"
            class="draggable-node"
          >
            <div class="highlight-bg"></div>
            <div class="bg"></div>
            <span class="text">{{ n.instruction.name }}</span>
            @if (n.instruction.block.type === BlockType.Value ||
            n.instruction.block.type === BlockType.End) {
            <div class="complexity-icons-container">
              <div class="complexity-icons">
                @for (complexity of [n.instruction.complexityPreparer,
                n.instruction.complexityReviewer1,
                n.instruction.complexityReviewer2]; track complexity) {
                <div
                  class="complexity-icon"
                  [ngClass]="{
                    'complexity-low': complexity == 1,
                    'complexity-medium': complexity == 2,
                    'complexity-high': complexity == 3
                  }"
                ></div>
                }
              </div>
            </div>
            }
            <div *cdkDragPreview class="node-drag-preview" [matchSize]="true" >
              <span class="text">{{ n.instruction.name }}</span>
            </div>
          </div>
        </div>
        }
      </div>
      }
      <div class="add-start" (click)="addNewStartPoint()">
        <div class="plus">
          <div class="horizontal"></div>
          <div class="vertical"></div>
        </div>
        {{ "settings.another-start-point" | transloco }}
      </div>
    </div>
  </div>

  @if (!isProductionMode) {
  <div class="skip-trace">
    <input type="checkbox" [(ngModel)]="skipTrace" />{{
      "settings.skip-trace-storage" | transloco
    }}
  </div>
  } @if (!isProductionMode) {
  <div class="save ui button primary" (click)="savePlan()">
    {{ "settings.save" | transloco }}
  </div>
  } @if (!isProductionMode) {
  <span class="sync container"
    ><div
      class="sync ui button primary"
      [ngClass]="{ loading: isSyncingCache }"
      (click)="syncCache()"
    >
      {{ "settings.sync-cache" | transloco }}
    </div></span
  >
  } @if (isPlanButtonVisiable) {
  <div class="plan ui button primary" (click)="listAvailablePlans()">
    {{ "settings.copy-plan" | transloco }}
  </div>
  }
</div>

<div class="block-sidebar">
  @if (!selectedNode && isPlanVisiable) {
  <div class="right-side-panel">
    @if (loading) {
    <div class="right-side-panel-wrapper">
      <div class="ui active centered inline loader"></div>
    </div>
    } @if (!loading && calculationPlans?.length == 0) {
    <div id="no-results">
      {{ "settings.no-calculation-plan-found" | transloco }}
    </div>
    }
    <div id="keyword-filter">
      <div class="ui left icon fluid input">
        <i class="search icon"></i>
        <input
          type="text"
          [(ngModel)]="planSearch"
          placeholder="{{ 'settings.search-plans' | transloco }}"
        />
      </div>
    </div>
    @if (!loading && calculationPlans?.length > 0) {
    <table id="list" width="100%" cellspacing="0">
      <tbody>
        @for (calc of calculationPlans | keyWord: ['questionId',
        'questionName']:planSearch; track calc) {
        <tr>
          <td
            [class.selected]="calc === selectedCalcPlan"
            (click)="selectPlan(calc)"
          >
            <strong class="question"
              >@if (showQuestionId) {
              <span>{{ calc.questionId }}.</span>
              } {{ questionsById[calc.questionId].question }}</strong
            >
            <span class="trail">{{
              questionsById[calc.questionId].trail
            }}</span>
          </td>
        </tr>
        }
      </tbody>
    </table>
    }
  </div>
  } @if (!selectedNode && !isPlanVisiable) {
  <div class="nothing-selected">
    {{ "settings.nothing-selected" | transloco }}
  </div>
  } @if (selectedNode && !isPlanVisiable) {
  <div class="node-info">
    <div class="top-row">
      @if (canCopyNode(selectedNode)) {
      <i
        class="copy alternate outline icon right"
        (click)="copyNode(selectedNode)"
        title="Copy block right"
      ></i>
      } @if (canCopyNode(selectedNode) && selectedNode.instruction.block.type
      === BlockType.Decision) {
      <i
        class="copy alternate outline icon down"
        (click)="copyNodeDown(selectedNode)"
        title="Copy block down"
      ></i>
      }
      <span class="block-name">
        @if (selectedNode.instruction.block.type === BlockType.Function ||
        selectedNode.instruction.block.type === BlockType.Decision) {
        <span>{{ selectedNode.instruction.block.type }} -</span>
        }
        {{ selectedNode.instruction.block.name }}
      </span>
      @if (canDeleteNode(selectedNode)) {
      <i
        class="trash alternate outline icon"
        (click)="deleteNode(selectedNode)"
        title="Delete block"
      ></i>
      }
      <div class="instruction-name">
        <input [(ngModel)]="selectedNode.instruction.name" />
      </div>
    </div>
    @if (selectedNode.instruction.block.type !== BlockType.Start) {
    <div class="from">
      <div class="subheading">{{ "settings.from" | transloco }}</div>
      <span
        class="tag"
        (click)="selectNode(selectedNode.prevNode)"
        (mouseenter)="instructionHovered(selectedNode.prevNode.instruction)"
        (mouseleave)="instructionHovered(null)"
        >{{ selectedNode.prevNode?.instruction?.name }}</span
      >
    </div>
    } @if (selectedNode.instruction.block.type === BlockType.Value) {
    <div
      class="inputs"
      title="{{ selectedNode.instruction.block.documentation.formula }}"
      [class.drop-hint]="draggingSource"
    >
      <div class="subheading">
        {{ "settings.final-value" | transloco
        }}<app-help-popup
          [description]="selectedNode.instruction.block.documentation"
        ></app-help-popup>
      </div>
      <div
        [attr.data-test-ref]="'blockDropZone'"
        class="calc-inputs-container value"
        cdkDropList
        [cdkDropListSortingDisabled]="true"
        [cdkDropListEnterPredicate]="sourceDropAllowed"
        (cdkDropListDropped)="dropSourceOnValue($event, selectedNode)"
      >
        @for (input of selectedNode.instruction.inputs; track input) {
        <app-calc-input
          [calcInput]="
            resolveInput(selectedChart.program, selectedNode.instruction, input)
          "
          (delete)="deleteCalcInput(selectedNode, input)"
          (instructionHovered)="instructionHovered($event)"
        ></app-calc-input>
        } @if (selectedNode.instruction.inputs.length === 0) {
        <div class="add-literal" (click)="addLiteral(selectedNode)">
          <div class="plus">
            <div class="horizontal"></div>
            <div class="vertical"></div>
          </div>
          {{ "settings.add-literal-field" | transloco }}
        </div>
        }
      </div>
    </div>
    } @if (selectedNode.instruction.block.type === BlockType.Warning) {
    <div
      class="inputs"
      title="{{ selectedNode.instruction.block.documentation.formula }}"
      [class.drop-hint]="draggingSource"
    >
      <div class="subheading">
        {{ "settings.Warning" | transloco }}
        <app-help-popup
          [description]="selectedNode.instruction.block.documentation"
        ></app-help-popup>
      </div>
      <div
        [attr.data-test-ref]="'blockDropZone'"
        class="calc-inputs-container"
        cdkDropList
        [cdkDropListSortingDisabled]="true"
        [cdkDropListEnterPredicate]="sourceDropAllowed"
        (cdkDropListDropped)="dropSourceOnValue($event, selectedNode)"
      >
        @for (input of selectedNode.instruction.inputs; track input) {
        <app-calc-input
          [calcInput]="
            resolveInput(selectedChart.program, selectedNode.instruction, input)
          "
          (delete)="deleteCalcInput(selectedNode, input)"
          (instructionHovered)="instructionHovered($event)"
        ></app-calc-input>
        } @if (selectedNode.instruction.inputs.length === 0) {
        <div class="add-literal" (click)="addLiteral(selectedNode)">
          <div class="plus">
            <div class="horizontal"></div>
            <div class="vertical"></div>
          </div>
          {{ "settings.add-literal-field" | transloco }}
        </div>
        }
      </div>
    </div>
    } @if (selectedNode.instruction.block.type === BlockType.Function ||
    selectedNode.instruction.block.type === BlockType.Decision) {
    <div
      class="inputs"
      [class.drop-hint]="draggingSource"
      title="{{ selectedNode.instruction.block.documentation.formula }}"
    >
      <div class="subheading">
        {{
          selectedNode.instruction.block.type === BlockType.Function
            ? "Inputs"
            : "Decision Inputs"
        }}<app-help-popup
          [description]="selectedNode.instruction.block.documentation"
        ></app-help-popup>
      </div>
      <div class="calc-inputs-container">
        <div
          class="block-def tag dark"
          cdkDropList
          [cdkDropListSortingDisabled]="true"
          [cdkDropListEnterPredicate]="replaceBlockAllowed(selectedNode)"
          (cdkDropListDropped)="replaceBlock($event, selectedNode)"
        >
          {{ selectedNode.instruction.block.name }}
        </div>
        <div
          [attr.data-test-ref]="'sourceDropZone'"
          class="source-drop-zone"
          cdkDropList
          [cdkDropListSortingDisabled]="true"
          [cdkDropListEnterPredicate]="sourceDropAllowed"
          (cdkDropListDropped)="dropSourceOnNode($event, selectedNode, 0)"
        >
          <div class="line"></div>
        </div>
        @for (input of selectedNode.instruction.inputs; track input; let i =
        $index) {
        <div
          cdkDropList
          cdkDropListHasAnchor
          [cdkDropListSortingDisabled]="true"
          [cdkDropListEnterPredicate]="falseListEnterPredicate"
        >
          <app-calc-input
            [calcInput]="
              resolveInput(
                selectedChart.program,
                selectedNode.instruction,
                input
              )
            "
            (delete)="deleteCalcInput(selectedNode, input)"
            cdkDrag
            [cdkDragData]="input"
            (instructionHovered)="instructionHovered($event)"
          >
          </app-calc-input>
        </div>
        <div
          class="source-drop-zone"
          cdkDropList
          [cdkDropListSortingDisabled]="true"
          [cdkDropListEnterPredicate]="sourceDropAllowed"
          (cdkDropListDropped)="dropSourceOnNode($event, selectedNode, i + 1)"
        >
          <div class="line"></div>
        </div>
        }
        <div class="add-literal" (click)="addLiteral(selectedNode)">
          <div class="plus">
            <div class="horizontal"></div>
            <div class="vertical"></div>
          </div>
          {{ "settings.add-literal-field" | transloco }}
        </div>
      </div>
    </div>
    } @if (selectedNode.instruction.block.type === BlockType.Function) {
    <div class="next">
      <div class="subheading">{{ "settings.next" | transloco }}</div>
      <div class="to">To</div>
      <span
        class="tag"
        (click)="selectNode(selectedNode.rightNode || selectedNode.downNode)"
        (mouseenter)="
          instructionHovered(
            (selectedNode.rightNode || selectedNode.downNode).instruction
          )
        "
        (mouseleave)="instructionHovered(null)"
        >{{
          (selectedNode.rightNode || selectedNode.downNode).instruction.name
        }}</span
      >
    </div>
    } @if (selectedNode.instruction.block.type === BlockType.Decision) {
    <div class="next">
      <div class="subheading">
        <span>{{ "settings.next" | transloco }}</span>
        <i
          class="ui icon exchange swap"
          title="Swap yes/no directions"
          (click)="swapDecisionDirection(selectedChart, selectedNode)"
        ></i>
      </div>
      <div class="decision-outputs">
        <div class="decision-next-container">
          <div class="decision-to">{{ "settings.true" | transloco }}</div>
          <span
            class="tag"
            (click)="selectNode(selectedNode.rightNode)"
            (mouseenter)="
              instructionHovered(selectedNode.rightNode.instruction)
            "
            (mouseleave)="instructionHovered(null)"
            >{{ selectedNode.rightNode.instruction.name }}</span
          >
        </div>
        <div class="decision-next-container">
          <div class="decision-to">{{ "settings.false" | transloco }}</div>
          <span
            class="tag"
            (click)="selectNode(selectedNode.downNode)"
            (mouseenter)="instructionHovered(selectedNode.downNode.instruction)"
            (mouseleave)="instructionHovered(null)"
            >{{ selectedNode.downNode.instruction.name }}</span
          >
        </div>
      </div>
    </div>
    } @if (selectedNode.instruction.block.type === BlockType.Value ||
    selectedNode.instruction.block.type === BlockType.End) {
    <div class="complexity">
      <div class="subheading">{{ "settings.complexity" | transloco }}</div>
      <div class="complexity-container">
        <div
          *ngTemplateOutlet="
            complexityDropdown;
            context: {
              complexityType: 'Prep',
              instruction: selectedNode.instruction,
              complexityField: 'complexityPreparer'
            }
          "
        ></div>
        <div
          *ngTemplateOutlet="
            complexityDropdown;
            context: {
              complexityType: 'Rev 1',
              instruction: selectedNode.instruction,
              complexityField: 'complexityReviewer1'
            }
          "
        ></div>
        <div
          *ngTemplateOutlet="
            complexityDropdown;
            context: {
              complexityType: 'Rev 2',
              instruction: selectedNode.instruction,
              complexityField: 'complexityReviewer2'
            }
          "
        ></div>
      </div>
    </div>
    }
    <div class="description">
      <div class="subheading">{{ "settings.description" | transloco }}</div>
      <textarea
        #description
        class="content"
        placeholder="{{ 'settings.enter-description-here' | transloco }}"
        [(ngModel)]="selectedNode.instruction.description"
        (input)="descriptionChanged($event)"
      ></textarea>
    </div>
  </div>
  }
</div>

<div #successModal class="ui tiny modal success-modal">
  <div class="icon modal-close close"></div>

  <div class="content">
    <div class="icon green-success"></div>
    <h3>{{ "settings.plan-saved-successfully" | transloco }}</h3>
  </div>

  <div class="actions">
    <div
      [attr.data-test-ref]="'calc-ok-button'"
      class="ui primary background button approve"
    >
      {{ "settings.ok" | transloco }}
    </div>
  </div>
</div>

<ng-template
  #complexityDropdown
  let-complexityType="complexityType"
  let-instruction="instruction"
  let-complexityField="complexityField"
>
  <div class="complexity-dropdown-container">
    <div class="complexity-type">{{ complexityType }}</div>
    <i class="icon chevron down"></i>
    <select
      [(ngModel)]="instruction[complexityField]"
      [ngClass]="{
        'complexity-low': instruction[complexityField] == 1,
        'complexity-medium': instruction[complexityField] == 2,
        'complexity-high': instruction[complexityField] == 3
      }"
    >
      <option [value]="1">1</option>
      <option [value]="2">2</option>
      <option [value]="3">3</option>
    </select>
  </div>
</ng-template>
